import {useFeatures} from '@udemy/react-experimentation-provider';
import {UDData} from '@udemy/ud-data';

import {
    REMOVE_SMARTBAR_FROM_BROWSE_PAGES,
    REMOVE_SMARTBAR_FROM_BROWSE_PAGES_ROUTES,
} from 'src/lib/experimentation-constants';

/**
 * Determines whether the global Smart Bar should render
 *
 * @param udData - UD data used to resolve the current page key
 * @param forceHide - When true always hides the Smart Bar
 */
export function useShouldShowSmartBar(udData?: UDData, forceHide?: boolean): boolean {
    const {featureVariantAssignments, isLoading} = useFeatures([REMOVE_SMARTBAR_FROM_BROWSE_PAGES]);

    const hideSmartBarInRoute = REMOVE_SMARTBAR_FROM_BROWSE_PAGES_ROUTES.includes(
        udData?.userAgnosticTrackingParams.page_key ?? '',
    );

    const hideSmartBar =
        hideSmartBarInRoute &&
        (featureVariantAssignments.get(REMOVE_SMARTBAR_FROM_BROWSE_PAGES)?.configuration
            ?.hideSmartBar ??
            false);

    // The experiment can only hide the Smart Bar on the routes above, so pages outside that list
    // don't wait for assignments: waiting would make the Smart Bar pop in late and cause CLS.
    const waitingOnExperiment = hideSmartBarInRoute && isLoading;

    return !forceHide && !waitingOnExperiment && !hideSmartBar;
}
